module.exports = __webpack_public_path__ + "static/media/parent.460bfa18.jpg";